(() => {
  const slidesOf = (gallery) => Array.from(gallery.querySelectorAll('[data-pdp-gallery-slide]'));

  const currentIndex = (gallery) => {
    const active = gallery.querySelector('[data-pdp-gallery-slide].is-active');
    return active ? Number(active.dataset.index) : 0;
  };

  const activate = (gallery, index) => {
    const total = slidesOf(gallery).length;

    slidesOf(gallery).forEach((slide) => {
      slide.classList.toggle('is-active', Number(slide.dataset.index) === index);
    });
    gallery.querySelectorAll('[data-pdp-gallery-thumb]').forEach((thumb) => {
      const selected = Number(thumb.dataset.index) === index;
      thumb.classList.toggle('is-active', selected);
      thumb.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    gallery.querySelectorAll('[data-pdp-gallery-step]').forEach((arrow) => {
      const target = index + Number(arrow.dataset.pdpGalleryStep);
      arrow.disabled = target < 0 || target >= total;
    });
  };

  const show = (gallery, index) => {
    activate(gallery, index);
    gallery
      .querySelector(`[data-pdp-gallery-slide][data-index="${index}"]`)
      ?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-pdp-gallery-thumb], [data-pdp-gallery-step]');
    if (!control) return;

    const gallery = control.closest('[data-pdp-gallery]');
    if (!gallery) return;

    const step = control.dataset.pdpGalleryStep;
    const index = step === undefined
      ? Number(control.dataset.index)
      : currentIndex(gallery) + Number(step);

    if (index < 0 || index >= slidesOf(gallery).length) return;
    show(gallery, index);
  });

  const track = (main) => {
    let ticking = false;

    main.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        const gallery = main.closest('[data-pdp-gallery]');
        const slides = Array.from(main.querySelectorAll('[data-pdp-gallery-slide]'));
        const mainLeft = main.getBoundingClientRect().left;
        let closest = slides[0];
        let closestDistance = Infinity;

        slides.forEach((slide) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - mainLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = slide;
          }
        });

        if (closest && gallery) activate(gallery, Number(closest.dataset.index));
        ticking = false;
      });
    }, { passive: true });
  };

  const initialize = (scope) => {
    scope.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => activate(gallery, currentIndex(gallery)));
    scope.querySelectorAll('[data-pdp-gallery-main]').forEach(track);
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
